import * as React from 'react';
import { connect } from 'react-redux';
import { Vegobjekttype } from '@/domain/vegobjekter/Vegobjekttype';
import { ColorIndex, resolveColor } from '@/utils/ColorHelper';

import { VegobjekttypeState } from '@/state';
import {
    removeVegobjekttype,
    removeVegobjekttypeT,
    toggleVegobjekttypeVisibility,
    toggleVegobjekttypeVisibilityT,
} from '@/actions/vegobjekterActions';
import '../../../stylesheets/5_components/limiter/what/WhatInfo.less';
interface TagProps {
    vegobjekttype: Vegobjekttype;
    vegobjekttypeData: VegobjekttypeState;
    farge: ColorIndex;
}

interface Props extends TagProps {
    doToggleVegobjekttypeVisibility: toggleVegobjekttypeVisibilityT;
    doRemoveRoadObjectType: removeVegobjekttypeT;
}

const mapDispatchToProps = {
    doRemoveRoadObjectType: removeVegobjekttype,
    doToggleVegobjekttypeVisibility: toggleVegobjekttypeVisibility,
};

const HvaInfoComponent: React.FC<Props> = ({
    vegobjekttype,
    vegobjekttypeData,
    farge,
    doToggleVegobjekttypeVisibility,
}) => {
    const { visible } = vegobjekttypeData;
    const visibilityIcon = vegobjekttype.isLine() ? 'timeline' : 'room';
    const iconColor = visible ? resolveColor(farge) : '#c6c6c6';

    return (
        <div className="c-hva-info">
            <button
                className="material-icons c-hva-info__visible"
                type="button"
                onClick={() => doToggleVegobjekttypeVisibility(vegobjekttypeData)}
                style={{ color: iconColor }}
                title={`Vis vegobjekttype ${vegobjekttype.navn} i kart`}
                aria-pressed={vegobjekttypeData.visible}
            >
                {visibilityIcon}
            </button>
        </div>
    );
};

export const HvaInfo = connect(null, mapDispatchToProps)(HvaInfoComponent);
